import "lazysizes";
import "@/style/pc/common.scss";
import "./responsibility.scss";

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Swiper from "swiper";
import "swiper/css/swiper.min.css";


gsap.registerPlugin(ScrollTrigger);

gsap.to(".pc-header", {
  backgroundColor: "#fff",
  height: WindowWidth < 903 ? "70px" : "80px",
  borderBottom: "1px solid #efefef",
  scrollTrigger: {
    trigger: ".responsibility-layer",
    start: "top",
    end: "top+=1",
    scrub: 0.3,
  },
});

gsap.to(".pc-header .logo", {
  width: "144px",
  height: "58px",
  scrollTrigger: {
    trigger: ".responsibility-layer",
    start: "top",
    end: "top+=1",
    scrub: 0.3,
  },
});

gsap.fromTo(".us-phone, nav .color-f, .us-phone .phone-number, .us-phone .phone-desc",
  { color: "#fff" },
  { color: "#1B451D",
  scrollTrigger: {
    trigger: ".responsibility-layer",
    start: "top",
    end: "top+=1",
    scrub: 0.3,
  },
});
gsap.to(".logo-img-white", {
  opacity: 0,
  scrollTrigger: {
    trigger: ".responsibility-layer",
    start: "top",
    end: "top+=1",
    scrub: 0.3,
  },
});


document
  .querySelector(".mobile-menu-btn")
  .addEventListener("click", function () {
    document.querySelector(".mobile-header-nav").classList.add("block");
  });
document
  .querySelector(".mobile-header-nav-close")
  .addEventListener("click", function (e) {
    document.querySelector(".mobile-header-nav").classList.remove("block");
    e.stopPropagation();
    e.preventDefault();
  });

// 移动端下拉菜单交互
document.querySelectorAll('.mobile-nav-parent').forEach(function(parent) {
  parent.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const dropdown = this.parentElement;
    const submenu = dropdown.querySelector('.mobile-submenu');
    const arrow = this.querySelector('.dropdown-arrow');
    
    // 切换当前菜单
    this.classList.toggle('active');
    submenu.classList.toggle('show');
  });
});

var WindowWidth = 0;
function updateScreenSize() {
  WindowWidth = document.documentElement.clientWidth;
}
updateScreenSize();
window.addEventListener("resize", updateScreenSize);

// 产业助农 Swiper
var helpSwiper = null;

function initHelpSwiper() {
  if (helpSwiper !== null) {
    helpSwiper.destroy(false);
  }

  const infoItems = document.querySelectorAll(".help-info");

  function showInfoByIndex(index) {
    infoItems.forEach(function (item) {
      item.classList.remove("active");
    });
    // Swiper loop mode 会产生 duplicate slides，realIndex 对应原始索引
    const realIndex = helpSwiper ? helpSwiper.realIndex : 0;
    const target = document.querySelector('.help-info[data-index="' + realIndex + '"]');
    if (target) target.classList.add("active");
  }

  helpSwiper = new Swiper(".help-swiper", {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    lazy: {
      loadPrevNext: true,
      loadOnTransitionStart: true,
    },
    navigation: {
      prevEl: ".help-swiper-prev",
      nextEl: ".help-swiper-next",
    },
    on: {
      slideChange: function () {
        showInfoByIndex(this.realIndex);
      },
    },
  });

  // 协同控制：hover 状态 + 可视区域状态
  let isHovered = false;
  let isVisible = true;

  function updateAutoplay() {
    if (!helpSwiper || !helpSwiper.autoplay) return;
    if (isHovered || !isVisible) {
      helpSwiper.autoplay.stop();
    } else {
      helpSwiper.autoplay.start();
    }
  }

  const wrapEl = document.querySelector(".help-swiper-wrap");
  if (wrapEl) {
    wrapEl.addEventListener("mouseenter", function () {
      isHovered = true;
      updateAutoplay();
    });
    wrapEl.addEventListener("mouseleave", function () {
      isHovered = false;
      updateAutoplay();
    });
  }

  // Intersection Observer：组件完全移出可视区域时暂停，进入时恢复
  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        isVisible = entry.isIntersecting;
        updateAutoplay();
      });
    },
    {
      threshold: 0,
    }
  );

  if (wrapEl) {
    observer.observe(wrapEl);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  initHelpSwiper();
});
